<yc-modal *ngIf="formGroup"
  [formGroup]="formGroup"
  [modalHeader]="'tags:hdrAddTags' | ycI18n: 'Add Tags'"
  [modalSubHeader]="modalSubHeader"
  [primaryButtonText]="'common:btnSave' | ycI18n:'Save'"
  [cancelButtonText]="'common:btnCancel' | ycI18n:'Cancel'"
  [primaryDisabled]="addingNewTag || formGroup.invalid"
  (onPrimaryClick)="handleSubmit()"
  (onCancel)="handleCancel()">
  <gc-system-tags-input
    [tagType]="bucket"
    [subTagType]="subBucket"
    [formGroup]="formGroup"
    [isNomination]="isNomination"
    [isBulk]="isBulk"
    controlName="tags"
    (onAddNewTagToggle)="addingNewTag = $event">
  </gc-system-tags-input>
</yc-modal>